export default "__VITE_ASSET__CeVv09R7__"